const SHADOW_MAP = [
  '0px 0px 17px rgba(0, 0, 0, 0.25);',
  '0px 0px 14px rgba(0, 0, 0, 0.1);',
];

export default (type?: number) => `
  box-shadow: ${SHADOW_MAP[type || 0]};
`;
